import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CartBaseCoreModule } from '@spartacus/cart/base/core';
import { PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';
import { CartPageLayoutHandlerService } from '../service/cart/cart-page-layout-handler.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, CartBaseCoreModule],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: CartPageLayoutHandlerService,
      multi: true,
    },
  ],
})
export class CartModule {}
